/* Dynamic load */
/* -------------------------------------------- */

var currentPage = window.location.href;
window.history.replaceState("", "", currentPage);
var $dynamicProgressBar = $('.dynamic-load-progress-bar .progress');
var loadTimer, bodyColor, navColor, metaTitle, $page, pageName, currentPage, target, thisPage, nextPage, transitionType;
var loading = false;
var initialLoaded = true;
var navbarToggler = $('.navbar-toggler');
var defaultTransition = 'slide-right';
var backwardTransition = 'slide-left';
var artworkTransition = 'artwork-right';
var timer = 0;
transitionType = defaultTransition;

//-------------- Dynamic clicks --------------//
$(document).on('click','.dynamic-link a, .nav-link', function(event){
    thisPage = window.location.href;
    nextPage = this.getAttribute('href');
    //Check if HREF target is on the same page
    if(nextPage != null && thisPage.split('/')[3] != nextPage.split('/')[3]) {
        event.preventDefault();

        if(!loading){
            var $this = $(this);
            loading = true;
            $(navLink).removeClass('active');
            $(this).addClass('active');
            $(navbarToggler).addClass('disable')
            transitionType = defaultTransition;
            dynamicLoad($this.attr('href'), transitionType, false, false);
        }
    } else {
        event.preventDefault();
    }
});

//-------------- Icon click --------------//
$(document).on('click','.navbar-brand', function(event){
    thisPage = window.location.href;
    nextPage = this.getAttribute('href');

    //Check if HREF target is on the same page
    if(nextPage != null && thisPage.split('/')[3] != nextPage.split('/')[3]) {
        event.preventDefault();

        if(!loading){
            var $this = $(this);
            loading = true;
            $(navLink).removeClass('active');
            $(this).addClass('active');
            $(navbarToggler).addClass('disable')
            transitionType = backwardTransition;
            dynamicLoad($this.attr('href'), transitionType, false, false);
        }
    } else {
        event.preventDefault();
    }
});

//-------------- Artwork click --------------//
$(document).on('click','.artwork-link', function(event){
    thisPage = window.location.href;
    nextPage = this.getAttribute('href');
    //Check if HREF target is on the same page
    if(nextPage != null && thisPage.split('/')[4] != nextPage.split('/')[4]) {
        event.preventDefault();

        if(!loading){
            var $this = $(this);
            loading = true;
            transitionType = $this.attr('data-transition');
            dynamicLoad($this.attr('href'), transitionType, false, false);
        }
    } else {
        event.preventDefault();
    }
});

//------ Active history change ------//
window.onpopstate = function(event) {
    event.preventDefault();

    var currentScroll = document.documentElement.scrollTop;

    setTimeout(function(){
        $('html, body').animate({ scrollTop: currentScroll }, 0);
    }, 1);

    transitionType = backwardTransition;
    dynamicLoad(window.location.href, transitionType, true, false);
};

//-------------- Get page HTML with Ajax --------------//
function dynamicLoad(target, transition, interactedBack, initialLoaded){
    $.ajax({
        method: 'GET',
        url: target,
        beforeSend: function() {
            if(currentPage.split('//')[1] == target.split('//')[1]) {
                loading = true;
                return true;
            } else {
                dynamicLoader(transition);
            }
        },
        success: function (data) {
            $page = $(data);
            $pageMain = $page.find("#main");
            metaTitle = $page.filter('title').text();
            $('head title').html(metaTitle);
            pageName = metaTitle.split(" – ")[0];
            pageTheme = $pageMain.attr('data-page-theme');
            footerClasses = $pageMain.attr('data-footer-classes');
            if(!interactedBack) window.history.pushState("", "", target);

            setTimeout(function(){
                $('main').replaceWith($pageMain[0].outerHTML);

                currentPage = target;
                initialLoaded = false;
            }, 350);

            $('html, body').scrollTop(0);
            windowY = 0;
        },
        error: function() {
            loading = false;
            window.location.href = siteUrl + '/page-not-found';
        },
        complete: function() {
            loading = false;
            if (!initialLoaded) {
                setTimeout(function(){
                    initPage(pageTheme, pageName, initialLoaded);
                }, 350);
            }
        }
    });
}

//-------------- Reinitialize JS functions and update menu --------------//
function initPage(pageTheme, pageName, initialLoaded){
    if (initialLoaded == false) {

        var videoPlayer = [];
        closeModal();
        initProjectsSlider();
        initArtworkSlider();
        initTimeline();
        circularText();
        onYouTubeIframeAPIReady();

        setTimeout(function(){ $($body).removeClass('bg-dark bg-light').addClass(pageTheme); }, 100);

        var bodyColorCode = bodyColor == "bg-white" ? "#FFFFFF" : "#0E0E0E";
        $("meta[name=theme-color]").attr('content', bodyColorCode);

        $('.navbar .menu').html(pageName);
        $('.menu-item').removeClass('active');
        navbarToggler.removeClass('disable');
        $($body).addClass('dom-rendered');


        $('.nav-link').each(function(){
            var $this = $(this);
            if($this.text() == pageName) $this.parent().addClass('active');
            if(currentPage.indexOf('project/') > 0 && $this.text() == 'Projects') $this.parent().addClass('active');
        });

        pageLoaded();
    }
}

//-------------- Loader --------------//
function dynamicLoader(transition){
    $($body).attr('id', 'dynamic-load').removeClass('dom-rendered');

    pageTransition(transition)
}

function pageTransition(transition){
    var dynamicSideBlock = $('.dynamic-sideblock');
    dynamicSideBlock.removeClass('slide-right slide-left artwork-right artwork-left d-none').addClass(transition + ' animate-sideblock');
    // setTimeout(function(){ dynamicSideBlock.removeClass('animate-sideblock').addClass('d-none'); } , 2150);
    // Unique transition for artwork page
    if (transition == 'artwork-right' || transition == 'artwork-left') {
        $('body').addClass(transition);
        // setTimeout(function(){ $('body').removeClass(transition); } , 2150);
    }
}

function pageLoaded() {
    if($('.section-contact')[0]) {
        $('footer').removeClass('hide').addClass('show');
    } else {
        $('footer').removeClass('show');
    }
    setTimeout(function(){
        $('.dynamic-sideblock').removeClass('animate-sideblock');
        $($body).removeClass('artwork-right artwork-left');
    }, 500);
    setTimeout(function(){
        $('.dynamic-sideblock').addClass('d-none');
    }, 1225);
}
